"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .tooltip__wrapper {
        position: relative;
    }

    .tooltip__text {
        border-radius: 4px;
        position: absolute;
        top: 110%;
        left: 50%;
        right: auto;
        transform: translateX(-50%);
        background: #000;
        color: #fff;
        font-size: 14px;
        padding: 5px;
        visibility: hidden;
        z-index: 10;
    }

    .tooltip__wrapper:hover .tooltip__text {
        visibility: visible;
    }

    @media(pointer: coarse) {
        .tooltip__wrapper_showPopup .tooltip__text {
            visibility: visible;
        }
    }
`;
